import React, { createContext, useEffect, useState } from "react";
import apibasic from "services/apibasic";
import config from "config";
import { getcodCidade } from "functions/gettabconfig";

const CidadeContext = createContext({});

function CidadeProvider(props){
    const [cod_cidade, setCodCidade] = useState(getcodCidade());
    const [cidades, setCidades] = useState([]);

    useEffect(() => {
        apibasic.get(config.CIDADES).then(response => setCidades(response.data))
        .catch(err => {
            console.log(err)
        });
    }, []);

return <CidadeContext.Provider value={{cod_cidade, setCodCidade, cidades}}>
        {props.children}
    </CidadeContext.Provider>
       
}


export {CidadeProvider, CidadeContext};